import * as d3 from 'd3';

export interface LineDefinition {
    x1: number;
    x2: number;
    y1: number;
    y2: number;
    color?: string;
}

export function renderLines(lines: LineDefinition[],
    selection: d3.Selection<any>, isVisible: boolean, classes?: string) {
    const databound = selection
        .classed('hidden-group', !isVisible)
        .selectAll('line')
        .data(lines);
    databound.exit()
        .remove();
    const enter = databound.enter()
        .append('line');
    if (classes !== null && classes !== undefined) {
        databound.classed(classes, true);
    }
    databound
        .attr('x1', d => d.x1)
        .attr('x2', d => d.x2)
        .attr('y1', d => d.y1)
        .attr('y2', d => d.y2)
        .style('stroke', d => d.color);
}